import { Directive, signal, viewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { getMinFilterLengthText } from '../../../core/util';

@Directive()
export abstract class BaseFilterComponent {
  protected readonly freeFilterLen = 3;
  protected freeFilter = '';
  protected readonly freeFilterChange = signal('');
  protected consumerFilter: string[] = [];
  protected subjectFilter: string[] = [];
  protected urlFilter = '';
  protected roleFilter: string[] = [];
  protected statusFilter = '';
  protected exerciseKindFilter = '';
  protected moduleFilter: string[] = [];
  protected learningUnitFilter: string[] = [];
  protected learningSectionFilter: string[] = [];
  protected selectedCanton: string | null = null;
  protected isbnFilter = '';
  protected regionFilter: string[] = [];

  protected pageSize = 25;
  protected pageIndex = 0;

  protected pageChange = signal({
    pageIndex: this.pageIndex,
    pageSize: this.pageSize
  });

  public currentSelectedRow = signal<string | undefined>(undefined);

  protected paginator = viewChild.required(MatPaginator);

  public setFreeFilter(input: string): void {
    this.freeFilter = input;
    this.freeFilterChange.set(input); // signal for feedbackComponent
    this.filterChanged();
  }

  public setConsumerFilter(selected: string[]): void {
    this.consumerFilter = selected;
    this.filterChanged();
  }

  public setSubjectFilter(selected: string[]): void {
    this.subjectFilter = selected;
    this.filterChanged();
  }

  public setUrlFilter(input: string): void {
    this.urlFilter = input;
    this.filterChanged();
  }

  public setRoleFilter(selected: string[]): void {
    this.roleFilter = selected;
    this.filterChanged();
  }

  public setStatusFilter(selected: string): void {
    this.statusFilter = selected;
    this.filterChanged();
  }

  public setKindFilter(selected: string): void {
    this.exerciseKindFilter = selected;
    this.filterChanged();
  }

  public setModuleFilter(selected: string[]): void {
    this.moduleFilter = selected;
    this.filterChanged();
  }

  public setLearningUnitFilter(selected: string[]): void {
    this.learningUnitFilter = selected;
    this.filterChanged();
  }

  public setLearningSectionFilter(selected: string[]): void {
    this.learningSectionFilter = selected;
    this.filterChanged();
  }

  public setCantonFilter(selected: string | null): void {
    this.selectedCanton = selected || null;
    this.filterChanged();
  }

  public setIsbnFilter(input: string): void {
    this.isbnFilter = input;
    this.filterChanged();
  }

  public setRegionFilter(selected: string[]): void {
    this.regionFilter = selected;
    this.filterChanged();
  }

  public getSearchFilterHint(): string {
    return getMinFilterLengthText(this.freeFilterLen);
  }

  protected filterChanged(): void {
    this.currentSelectedRow.set(undefined);
    this.pageIndex = 0;

    this.paginator().pageIndex = 0;

    const currentPageSize = this.pageChange().pageSize;

    this.pageChange.set({
      pageIndex: 0,
      pageSize: currentPageSize
    });
  }
}
